import { render, staticRenderFns } from "./PdfAdminHeader.vue?vue&type=template&id=785bd8d6&scoped=true&"
import script from "./PdfAdminHeader.vue?vue&type=script&lang=js&"
export * from "./PdfAdminHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bd8d6",
  null
  
)

export default component.exports